<template>
    <div class="pt-2 pl-2">
        <v-row no-gutters>
            <v-col cols="6" class="pr-1">
                <v-card class="default_card_wm elevation-0 pt-2">
                    <DocumentMenu 
                        :MenuOptions="documentMenuOptions"
                        @back="back()"
                        @display-file="showAccountingLines = false; displayActivity = false;"
                        @display-accounting-line="showAccountingLines = true; displayActivity = false;"
                        @download="startDownloadFile()"
                        @upload="dialogUploadDocument = true"
                        @activity="displayActivity = true"
                        @delete="deleteDocumentDialog = true"
                    />
                    <v-row no-gutters>
                        <!--
                        <v-col cols="6" class="d-flex align-center">
                            <v-btn-back
                                @click.stop="back()"
                                v-if="mode !== 'GeneralLedger' && goBackHistory"
                                data-cy="document-back"
                            />
                            <!-- <h2>Page Document Abonnement</h2> -->
                             <!--
                        </v-col>
                        <v-col cols="6" class="d-flex justify-end">
                            <v-btn-toggle
                                v-if="document.signedUrl && isAccountingUser"
                                v-model="showAccountingLines"
                                rounded="xl"
                                class="mt-1"
                                density="compact"
                                outlined
                                mandatory
                                color="secondary"
                            >
                                <v-btn-icon
                                    icon="$oss-file"
                                    :value="0"
                                    @click="
                                        showAccountingLines = false;
                                        displayActivity = false;
                                    "
                                />
                                <v-btn-icon
                                    icon="$oss-accounting-lines"
                                    :value="1"
                                    @click="
                                        showAccountingLines = true;
                                        displayActivity = false;
                                    "
                                />
                            </v-btn-toggle>
                            <v-btn-icon
                                icon=" $oss-file "
                                v-else-if="document.signedUrl && displayActivity"
                                color="secondary"
                                class="mx-1"
                                @click="displayActivity = false"
                            />
                            <v-btn-icon
                                icon="$oss-download"
                                color="secondary"
                                class="mx-1"
                                :disabled="!document.signedUrl"
                                @click="startDownloadFile"
                            />
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn-icon
                                        icon="$dots_vertical"
                                        v-bind="props"
                                        class="mx-1"
                                        color="secondary"
                                    />
                                </template>
                                <v-list nav rounded="xl">
                                    <v-list-item
                                        @click="startDownloadFile"
                                        v-if="document.signedUrl"
                                    >
                                        <v-list-item-title
                                            >Télécharger le document</v-list-item-title
                                        >
                                        <template v-slot:append>
                                            <v-icon>$oss-download</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item @click="dialogUploadDocument = true" v-else>
                                        <v-list-item-title>Ajouter un document</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-upload</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-list-item
                                        @click="displayActivity = true"
                                        v-if="isAccountingUser"
                                    >
                                        <v-list-item-title>Afficher l'activité</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon>$oss-activity</v-icon>
                                        </template>
                                    </v-list-item>
                                    <v-divider class="mb-2" />
                                    <v-list-item
                                        @click="deleteDocumentDialog = true"
                                        :disabled="disabledDelete"
                                        color="error"
                                        :active="!disabledDelete"
                                    >
                                        <v-list-item-title>Supprimer</v-list-item-title>
                                        <template v-slot:append>
                                            <v-icon size="small">$oss-trash</v-icon>
                                        </template>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-col>
                        -->
                        <v-col cols="12" v-if="isPDF" class="d-flex justify-center">
                            <ossPdf :documentId="document.id" />
                        </v-col>
                        <template
                            v-if="showAccountingLines && !displayActivity && isAccountingUser"
                        >
                            <!--- AccountingItemStaticFull -->
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <accounting-item-static
                                    :companyId="companyId"
                                    :documentId="document.id"
                                    :mode="isAccountingItem ? 'AllOption' : 'Embedded'"
                                    ref="accountingItemStatic"
                                    :key="accountingLinesRefreshKey"
                                    @upsert="onAccountingItemUpdated"
                                />
                            </v-col>
                        </template>
                        <template v-else-if="displayActivity">
                            <v-col cols="12" style="height: calc(100vh - 130px); overflow-y: auto">
                                <UsersActivitiesHistory :documentId="document.id">
                                </UsersActivitiesHistory>
                            </v-col>
                        </template>
                    </v-row>
                </v-card>
                <v-list v-if="associatedFields.show" :style="svgPosition">
                    <v-list-item
                        v-for="(field, key, index) in associatedFields.fields"
                        :key="`field-${document.id}-${key}-${index}`"
                        @click="onFieldAssociation(field, key)"
                        class="oss-list-item"
                    >
                    </v-list-item>
                </v-list>
            </v-col>
            <v-col cols="6" class="my-0 pl-1">
                <v-card
                    style="
                        border-top-right-radius: 0px !important;
                        border-bottom-right-radius: 0px !important;
                        height: calc(100vh - 82px);
                        overflow-y: auto;
                    "
                    class="default_card_wm elevation-0 rounded-l-0"
                >
                    <v-card-text class="pt-0">
                        <v-row no-gutters>
                            <v-col cols="8" />
                            <v-col cols="2" class="mt-2 d-flex align-right justify-end">
                                <v-btn
                                    rounded
                                    dense
                                    elevation="0"
                                    @click="unsubscribe()"
                                    size="small"
                                >
                                    Résilier
                                </v-btn>
                            </v-col>
                            <v-col cols="2" class="pl-1 mt-2 d-flex align-right justify-end">
                                <v-btn-edit @click="editSubscription()" size="small"> </v-btn-edit>
                            </v-col>
                            <v-col cols="12" class="mt-2">
                                <v-list class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Statut</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div
                                                        v-if="
                                                            document.errorMessage &&
                                                            reUploadDocument
                                                        "
                                                        style="color: red"
                                                    >
                                                        Erreur : {{ document.errorMessage }}
                                                    </div>
                                                    <div
                                                        v-else-if="document.errorMessage"
                                                        style="color: red"
                                                    >
                                                        Erreur de lecture du fichier : contacter
                                                        votre cabinet
                                                    </div>
                                                    <div
                                                        v-else-if="
                                                            document.status === 'ORIGINAL_UPLOADED'
                                                        "
                                                    >
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else-if="document.status === 'UPLOADED'">
                                                        En attente d'analyse
                                                    </div>
                                                    <div v-else>OK</div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item :ripple="false" class="oss-list-item my-2">
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="
                                                        border-right: 1px #ededed solid;
                                                        height: 28px;
                                                    "
                                                    class="d-flex align-center"
                                                >
                                                    <b>Type</b>
                                                </v-col>
                                                <v-col cols="9" class="pl-2">
                                                    {{ formatCategory(document.type) }}
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="mb-2"
                                        color="success"
                                        v-if="showRestoreDocumentBtn"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters class="align-center">
                                                <v-col
                                                    cols="3"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Actions</b>
                                                </v-col>
                                                <v-col
                                                    cols="9"
                                                    class="d-flex justify-end align-center"
                                                >
                                                    <v-tooltip
                                                        v-if="canBeRestoredTooltipMessages?.length"
                                                        class="pt-4 px-4"
                                                        location="bottom"
                                                    >
                                                        <template v-slot:activator="{ props }">
                                                            <div style="height: fit-content" v-bind="props">
                                                                <v-btn
                                                                    rounded
                                                                    elevation="0"
                                                                    disabled
                                                                    size="small"
                                                                >
                                                                    Restaurer
                                                                    <v-icon size="small" location="end">
                                                                        $oss-edit
                                                                    </v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </template>

                                                        <template v-for="line of canBeRestoredTooltipMessages">
                                                            <h4>
                                                                {{ line }}
                                                            </h4>
                                                        </template>
                                                    </v-tooltip>

                                                    <template v-else>
                                                        <v-btn
                                                            rounded
                                                            elevation="0"
                                                            @click="restoreDialog = true"
                                                            size="small"
                                                        >
                                                            Restaurer
                                                            <v-icon size="small" location="end">
                                                                $oss-edit
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col v-if="activateTagguing">
                                <FreeTag
                                    :companyTags="allCompanyTags"
                                    :document="inDocument"
                                    :splitUserPartitions="true"
                                    @changed="startToBeDoneIfNecessary"
                                />
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mt-2">
                            <v-col class="d-flex align-center col-auto pr-3 title">
                                Informations abonnement
                            </v-col>
                            <v-col class="d-flex align-center">
                                <v-divider />
                            </v-col>
                            <v-col cols="12">
                                <v-list single-line class="pt-0" density="compact">
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mt-1 mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Nom</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>
                                                        {{ document.data.subscription.title }}
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-itemmt-1 mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Date</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>
                                                        {{
                                                            displayDocumentDate(
                                                                document.data.subscription
                                                                    .startDate,
                                                            )
                                                        }}
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mt-1 mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>Durée abonnement</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>
                                                        {{ document.data.subscription.periodicity }}
                                                        Mois
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <v-list-item
                                        :ripple="false"
                                        class="oss-list-item mt-1 mb-2"
                                        color="success"
                                    >
                                        <v-list-item-title class="body-1">
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="3"
                                                    class="d-flex align-center"
                                                    style="border-right: 1px #ededed solid"
                                                >
                                                    <b>HT Mensuel</b>
                                                </v-col>
                                                <v-col cols="6" class="d-flex align-center pl-2">
                                                    <div>
                                                        {{ document.data.subscription.netAmount }}
                                                        &#x20ac;
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-list-item-title></v-list-item
                                    >
                                    <!-- <v-list-item
                                            :ripple="false"
                                            class="oss-list-item mt-1 mb-2"
                                            color="success"
                                        >
                                            <template>
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters>
                                                        <v-col cols="3" class="d-flex align-center" style="border-right: 1px #EDEDED solid;">
                                                            <b>TVA Mensuel</b>
                                                        </v-col>
                                                        <v-col cols="6" class="d-flex align-center pl-2">
                                                            <div>{{document.data.subscription.grossAmount - document.data.subscription.netAmount}} €</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-title>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            :ripple="false"
                                            class="oss-list-item mt-1 mb-2"
                                            color="success"
                                        >
                                            <template>
                                                <v-list-item-title class="body-1">
                                                    <v-row no-gutters>
                                                        <v-col cols="3" class="d-flex align-center" style="border-right: 1px #EDEDED solid;">
                                                            <b>TTC Mensuel</b>
                                                        </v-col>
                                                        <v-col cols="6" class="d-flex align-center pl-2">
                                                            <div>{{document.data.subscription.grossAmount}} €</div>
                                                        </v-col>
                                                    </v-row>
                                                </v-list-item-title>
                                            </template>
                                        </v-list-item> -->
                                </v-list>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn-prev :disabled="previousDisabled()" @click="previous()" />
                                <v-btn-next :disabled="nextDisabled()" @click="next()" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <DocumentWizardDialog
            v-model:active="activeUploadDocument"
            v-bind:companyId="companyId"
            v-bind:documentId="document.id"
            v-bind:documentType="document.type"
            v-bind:showFirstPrevious="false"
            v-bind:multiple="false"
            @fileUploaded="onFileUploaded"
        />
        <oss-dialog
            v-model="deleteDocumentDialog"
            title="Supprimer le document"
            :error="true"
            @valid="deleteDocument"
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="deleteDocumentLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir supprimer le document ?</h4>
        </oss-dialog>
        <oss-dialog
            v-model="isUnsubscribing"
            title="Résilier l'abonnement"
            :error="true"
            @valid="unsubscribeDocument"
            :validTitle="'Résilier'"
            :validLoading="unsubscribeDocumentLoading"
            width="800px"
        >
            <v-select-filled
                v-model="unsubscribeDate"
                :items="unsubscribeDates"
                label="Date de résiliation"
                item-value="value"
                outlined
                hide-details
                density="compact"
                :item-title="(item) => item.text"
            />
        </oss-dialog>
        <Chat
            v-if="openChat"
            v-bind:id="document.chat ? document.chat.id : ''"
            v-bind:status="'INFORMATION_REQUEST'"
            :showSmartChat="false"
        />
        <oss-dialog
            v-model="restoreDialog"
            title="Restaurer le document"
            @valid="
                restoreDocument();
                restoreDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            :validLoading="restoreLoading"
            width="800px"
        >
            <h4 class="text-center">&#xca;tes-vous sûr(e) de vouloir restaurer le document ?</h4>
        </oss-dialog>
        <Subscriptions
            v-model="isEditSubscription"
            v-if="isEditSubscription"
            :companyId="selectedCompany.id"
            :document="document"
            @edit-done="isEditSubscription = false"
        >
        </Subscriptions>
        <oss-dialog
            v-model="dialogUploadDocument"
            title="Importer un document pour ce justificatif"
            max-width="60vw"
            :actions="actions"
        >
            <UploadDocument
                :showFirstPrevious="false"
                :companyId="companyId"
                :documentId="document.id"
                :documentType="'MISCELLANEOUS'"
                :multiple="false"
                :freeTag="false"
                :showBtns="true"
                :actions="actions"
                @fileUploaded="
                    closeUploadDocumentDialog();
                    startToBeDoneIfNecessary();
                "
            />
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { User } from "../../../../types";

import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";
import UPDATE_DOCUMENT_NAME from "../../graphql/document/UpdateDocumentName.gql";
import UNSUBSCRIBE_SUBSCRIPTION from "../../graphql/subscriptions/UnsubscribeSubscription.gql";

import { DocumentBase } from "./DocumentBase";
import ossPdf from "./DocumentPDF.vue";
import DocumentWizardDialog from "./DocumentWizardDialog.vue";
import { DocumentMenu } from "./DocumentMenu.vue";
import Chat from "../chat/Chat.vue";
import FreeTag from "../tag/FreeTag.vue";
import Sepa from "../pay/Sepa.vue";
import AccountingItemStatic from "../AccountingItemStatic.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import Subscriptions from "../subscriptions/Subscriptions.vue";
import UploadDocument from "./UploadDocuments.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { DialogAction } from "@/services/dialogAction";
import { MenuDisplayDisplayModeOptions, MenuDisplayDotMenuOptions, MenuDisplayDownloadOptions, MenuDisplayOptions } from "@/types/documentMenu.types";

import documentMenuDisplayOptionsDefaultScheme from "@/assets/json/documentMenuMenuDisplayOptionDefaultScheme.json";

@Component({
    components: {
        DocumentWizardDialog,
        Chat,
        ossPdf,
        FreeTag,
        Sepa,
        AccountingItemStatic,
        UsersActivitiesHistory,
        Subscriptions,
        UploadDocument,
        DocumentMenu,
    },
    emits: ["onEdit"],
})
export class DocumentSubscription extends DocumentBase {
    items: Array<any> = [];

    valid = false;

    loading = false;

    updating = false;

    isEditSubscription = false;

    isUnsubscribing = false;

    unsubscribeDocumentLoading = false;

    unsubscribeDate = null;

    dialogSelectCompany = false;

    dialogUploadDocument = false;

    activeUploadDocument = false;

    showAccountingLines: boolean = false;

    restoreDialog = false;

    actions = {
        action: new DialogAction(),
    };

    get documentMenuDownloadOptions(): MenuDisplayDownloadOptions {
        const downloadButton: MenuDisplayDownloadOptions = { ...documentMenuDisplayOptionsDefaultScheme.downloadButton };

        downloadButton.isDisplay = true;
        downloadButton.disabled = !this.document.signedUrl;

        return downloadButton;
    }

    get documentMenuDisplayModeOptions(): MenuDisplayDisplayModeOptions {
        const displayMode: MenuDisplayDisplayModeOptions = { ...documentMenuDisplayOptionsDefaultScheme.displayModeButtons };

        displayMode.isDisplay = (this.document.signedUrl && this.isAccountingUser) || (this.document.signedUrl && this.displayActivity);
        displayMode.isAccountingLineModeDisplay = (this.document.signedUrl && this.isAccountingUser && this.document.accountingLines?.length);
        displayMode.isPDFModeDisplay = (this.document.signedUrl && this.isAccountingUser) || (this.document.signedUrl && this.displayActivity);

        return displayMode
    }

    get documentMenuDotMenuOptions(): MenuDisplayDotMenuOptions {
        const dotMenu: MenuDisplayDotMenuOptions = { ...documentMenuDisplayOptionsDefaultScheme.dotMenu };

        dotMenu.isDisplay = true;

        dotMenu.download.isDisplay = !!this.document.signedUrl;
        dotMenu.download.title = "Télécharger le document"

        dotMenu.upload.isDisplay = !this.document.signedUrl;
        dotMenu.upload.title = "Ajouter un document";

        dotMenu.activity.isDisplay = this.isAccountingUser;
        dotMenu.activity.title = "Afficher l'activité";
        
        dotMenu.delete.isDisplay = true;
        dotMenu.delete.title = "Supprimer";
        dotMenu.delete.disabled = this.disabledDelete;

        return dotMenu;
    }

    get documentMenuOptions():MenuDisplayOptions {
        const documentMenuOption: MenuDisplayOptions = { ...documentMenuDisplayOptionsDefaultScheme };

        documentMenuOption.downloadButton = this.documentMenuDownloadOptions;
        documentMenuOption.displayModeButtons = this.documentMenuDisplayModeOptions;
        documentMenuOption.dotMenu = this.documentMenuDotMenuOptions;

        return documentMenuOption;
    }

    get reUploadDocument() {
        if (!this.document) return false;
        if (this.currentUser.profile.configuration.document.write) {
            return true;
        }
        return false;
    }

    documentType_ = "";

    get documentType() {
        if (this.documentType_) {
            return this.documentType_;
        }
        return this.document.type;
    }

    set documentType(data) {
        this.documentType_ = data;
    }

    get disabledChangeType() {
        if (this.documentType === "MISCELLANEOUS") {
            return true;
        }
        if (
            (this.documentType === "CURRENT_ACCOUNT" ||
                (this.documentType === "OPERATOR_ACCOUNT" && !this.isAutonomousUser)) &&
            !(this.currentAccountUser && this.currentAccountUser.id)
        ) {
            return true;
        }
        return false;
    }

    get unsubscribeDates() {
        const unsubscribeDates = [];

        if (this.document.fromDocumentOf) {
            for (const document of this.document.fromDocumentOf) {
                if (document.date) {
                    unsubscribeDates.push({
                        value: document.date,
                        text: moment(document.date).format("DD/MM/YYYY"),
                    });
                }
            }
        }

        return unsubscribeDates;
    }

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    this.updateCurrentAccountUser();
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    displayDocumentDate(date) {
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }

        return "";
    }

    editSubscription() {
        this.isEditSubscription = true;
    }

    unsubscribe() {
        this.isUnsubscribing = true;
    }

    updateCurrentAccountUser() {
        const currentAccountUsers = this.getUsers();
        if (currentAccountUsers.length) {
            if (this.inDocument.owner) {
                const foundUser = currentAccountUsers.find(
                    (u) => u.id === this.inDocument.owner.id,
                );
                if (foundUser) {
                    this.currentAccountUser = foundUser;
                } else {
                    this.currentAccountUser = currentAccountUsers[0];
                }
            } else {
                this.currentAccountUser = currentAccountUsers[0];
            }
        } else {
            this.currentAccountUser = this.defaultUser;
        }
    }

    onFileUploaded() {
        // this.uploadFileLoading = false;
    }

    closeUploadDocumentDialog() {
        this.dialogUploadDocument = false;
        this.$emit("onEdit");
    }

    @Watch("documentId")
    onDocumentChanged(prev, next) {
        if (prev !== next) {
            this.clearVariantList();
            this.document = this.inDocument;
            // debugger
            if (this.document.signedUrl && !this.isPDF) {
                this.zoomManager.instanciateSvgZoom(this.svgSuffix);
            }
            if (!this.document?.signedUrl && this.isAccountingUser) {
                this.showAccountingLines = true;
            }
        }
    }

    beforeMount() {
        this.svgSuffix = "document-miscellaneous";
        //
        this.onDocumentChanged(this.inDocument.id, undefined);
        if (!this.document.displayName) {
            this.document.displayName = this.document.name;
        }
        this.finishMounted();

        debugger;

        if (this.document?.data?.subscription?.aaSubscriptionName) {
            this.document.data.subscription.aaSubscriptionName =
                this.document.data.subscription.aaSubscriptionName.substring(0, 6);
        }
    }

    switchToDocumentValidationDialog: boolean = false;

    async switchToDocumentValidation() {
        await this.updateDocument("ANALYSED");
        this.$emit("edit", {
            documentId: this.documentId,
        });
        this.switchToDocumentValidationDialog = false;
    }

    formatOrderBy() {
        const fieldName = this.pagination.sortBy[0] || "type";
        let direction = "";
        if (fieldName !== "updatedAt") {
            direction = this.pagination.descending[0] ? "_DESC" : "_ASC";
        } else {
            direction = this.pagination.descending[0] ? "_ASC" : "_DESC";
        }
        return fieldName + direction;
    }

    async updateDocument(status) {
        await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_NAME,
            variables: {
                id: this.document.id,
                name: this.document.displayName,
            },
        });
    }

    async validateSepa() {
        // debugger
        await this.updateDocument("ORIGINAL_UPLOADED");

        this.$emit("edit", {
            documentId: this.documentId,
        });
    }

    async unsubscribeDocument() {
        this.unsubscribeDocumentLoading = true;

        const unsubscribedDocument = await this.$apollo.mutate({
            mutation: UNSUBSCRIBE_SUBSCRIPTION,
            variables: {
                id: this.document.id,
                unsubscribeDate: moment(this.unsubscribeDate),
            },
        });

        if (unsubscribedDocument?.data?.unsubscribeSubscription) {
            this.unsubscribeDocumentLoading = false;
            this.isUnsubscribing = false;
            this.$router.go(-1);
        }
    }

    //
    // CHAT
    //
    open_chat: boolean = false;

    get openChat() {
        if (this.document.chat) {
            return true;
        }
        return this.open_chat;
    }

    // space(indent) {
    //     // return ""
    //     let space = ""
    //     let i = 0
    //     while (i < indent) {
    //         space += " "
    //         i++
    //     }
    //     return space
    // }
}

export default toNative(DocumentSubscription);
</script>
<style lang="scss" scoped>
.v-input--has-state.text-red .v-label {
    animation: none !important;
    transition: none !important;
}

.theme--light.v-label {
    color: black !important;
}

.svg-pan-zoom_viewport {
    transition: transform 0.4s ease-out !important;
}

.inline-text-field {
    max-width: 140px;
    margin-right: 10px;
    display: inline-block;
}

.text-field-icon--associated {
    display: flex;
}

i.inline-icon {
    display: flex;
    height: 55px;
    width: 30px;
}

polygon.highlighted {
    fill: rgba(249, 177, 42, 0.5) !important;
}

.v-input--is-disabled {
    pointer-events: all !important;
}
</style>
